export const PartnerPermission = Object.freeze({
  partnerAdmin: 'administer-vendor',
  managePartnerDetails: 'manage-vendor-details',
  managePayment: 'manage-payment',
  manageAppDetails: 'manage-addon-details',
  manageAppPricing: 'manage-pricing',
  managePromotions: 'manage-promotions',
  viewSaleReports: 'view-sales-reports',
  viewUsageReports: 'view-usage-reports'
});
export const PartnerRole = Object.freeze({
  engineering: 'engineering',
  marketing: 'marketing',
  finance: 'finance',
  primary: 'primary',
  support: 'support',
  security: 'security',
  migrations: 'migrations',
  salesSupportAndApprovals: 'salessupportandapprovals'
});